export const PREVIEW_BLUE_BACKGROUND =  '#0075ff';
export const PREVIEW_DARKER_GRAY = '#8c8c8c';
export const PREVIEW_GRAY = '#8e8e93';
export const PREVIEW_LIGHT_GRAY='#c8c7cc';
export const PREVIEW_VERY_DARK_GRAY = '#505050';
export const PREVIEW_WHITE = '#ffffff';
export const ERROR_COLOR = '#a94442';
export const BORDER_GRAY = '1px solid rgb(200, 199, 204)';

export const COLORS = {
  BLACK: '#000',
  STARS: '#FFA000',
  PRIMARY: '#FF4081',
  SECONDARY: '#03A9F4',
  GREY_LIGHT: '#EFEFEF',
  WHITE: '#FFFFFF',
  GREY_TEXT: '#aaaaaa',
  GREY_ICON: '#d9d9d9',
  HOVER_PANEL: '#fafafa',
  BORDER: '#cccccc',
  CARD_BACKGROUND: '#f6f6f6',
  SHADOW_COLOR: '#cfcfcf',
  ICON_HOVER_COLOR: '#595959',
  ICON_COLOR: '#9f9fa4',
  CHECKBOX_TEXT_COLOR: '#929297',
  CHECKBOX_BACKGROUND_COLOR: '#5081ff',
  CHECKBOX_DISABLED: '#F8F8F8',
  GREY_BORDER_HEADER: '#c8c7cc',
  GREY_BORDER_HEADER_WITH_OPACITY: '#c8c7cc6b',
  EDIT_ICON: '#5081ff',
  DANGER: '#d43f3a',
  ROW_HOVER: '#f2f2f2',
  ROW_BORDER: '#e2e2e4',
  EXTRA_DARK_GREY: '#5b5b60',
  REQUIRED: 'red',
  MDIGITAL_BLUE: '#5081ff',
  BLUE_BTN: '#007AFF',
  HOVER_BLUE_BTN: '#007affa1',
  LIGHT_BLUE_BTN: '#C7E2FF',
  SELECTED_BACKGROUND_BLUE: '#5A84FF',
  GREY_SEPARATOR: '#D9D9D9',
  GREY_BORDER: '#A1A1A1',
  GREY_BTN: '#8e8e93',
  GREEN_BTN: '#5BB95B',
  DARK_GREEN_BTN: '#4D9E4D',
  RADIO_BUTTON_CHECKED: '#007AFF',
  ICON_HOVER: '#808080',
  ICON_ACTIVE: '#595959',
  MEDALLIA_BLUE: '#007AFF',
  INPUT_COUNTER: '#C7C7C9',
  DARK_GREY: '#707070',
  WHITE_WITH_DECREASED_OPACITY: '#8E94A3',
  LIGHT_BLUE: '#2196f3',
  // Messages
  SUCCESS: '#dff0d8',
  SUCCESS_TEXT: '#3c763d',
  FAILURE: '#f2dede',
  FAILURE_TEXT: '#a94442',

  // Side navigation
  BACKGROUND_DARK: '#121826',
  HOVER_DARK: '#242C3D',

  // List
  LIGHT_GREY: '#9F9FA4',
  TEXT: '#5b5b60',
  SELECTED_BLUE: '#5080FF',
  HOVER_BACKGROUND: '#F0EFF0',

  // Selection group
  FONT_GREY: '#929ea6',
  BACKGROUND_GREY: '#e6e8e8',

  // Introduction:
  ACTIVE_BLUE: '#006aff',
  TEXT_COLOR: '#595959',

  // Expandable List
  LABEL_TEXT_COLOR: '#272727',
};

export default COLORS;
